import { useQuery } from '@tanstack/react-query'
import { IApiBaseTypes } from '@/types/query-api'
import { APIInstance } from '@/utils/functions/instance'
import { IGetProvincesResponseType } from './type'
import { IResponseType } from '@/types/response-type'
import { IPaginatedResponse } from '../category/type'

export function useGetProvinces({
  data,
  disableToast,
  ...rest
}: IApiBaseTypes<{}>) {
  return useQuery({
    queryFn: async () =>
      await APIInstance<IPaginatedResponse<IGetProvincesResponseType>>({
        url: 'mrf/provinces/',
        params: data,
        method: 'get',
        data
      }),
    queryKey: ['province-item', data],
    select: (data) => data?.data,
    retry: 0,
    ...rest
  })
}
